// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH } from 'config';

// mini rail width (icon + text under icon style usually looks best at 80–96px)
const MINI_WIDTH = 92;

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  marginTop: '64px', // 👈 starts below header
  height: 'calc(100% - 64px)',
  borderRight: '1px solid',
  borderRightColor: theme.palette.divider,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'visible',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
});

const closedMixin = (theme) => ({
  width: MINI_WIDTH,
  marginTop: '58px', // 👈 same here
  height: 'calc(100% - 64px)',
  borderRight: '1px solid',
  borderRightColor: theme.palette.divider,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'visible',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
});

// ==============================|| DRAWER - MINI STYLED ||============================== //
const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  // extra safety: paper must also allow overflow
  '& .MuiDrawer-paper': {
    overflow: 'visible'
  },

  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': {
          ...openedMixin(theme),
          overflow: 'visible'
        }
      }
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': {
          ...closedMixin(theme),
          overflow: 'visible'
        }
      }
    }
  ]
}));

export default MiniDrawerStyled;
